<template>
    <div>
        <Navigation :route="navigationRoute"></Navigation>
        <div>
            <div class="paper-item"
                :class="{ 'paper-item-df': e.examDataStatus && e.examDataStatus != 'WJJ'  }"
                v-for="(e, i) in list" :key="i">
                <div class="paper-item-left">
                    <div class="paper-item-title overS">
                        {{ e.name || '' }}
                    </div>
                    <div class="overS">
                        说明： {{ e.remark || '' }}
                    </div>
                    <div class="paper-item-left-b">
                        <div>考试时间：{{ e.startTime |dateFormat('yyyy.MM.dd HH:mm') }} - {{ e.endTime|dateFormat('yyyy.MM.dd HH:mm') }}</div>
                        <div>及格分/总分：{{ e.passedScore || '' }}/{{ e.totalScore || '' }}</div>
                        <div>考试时长：{{ e.duration || '' }}分钟</div>
                    </div>
                </div>
                <div class="paper-item-right">
                    <el-button type="warning" size="mini" v-if="!e.examDataId" @click="start(e)">开始考试</el-button>
                    <el-button type="warning" size="mini" v-if="e.examDataStatus == 'WJJ' && e.examDataId"
                        @click="start(e)">继续考试</el-button>
                    <div @click="view(e)"
                        v-if="e.examDataStatus && e.examDataStatus != 'WJJ' "
                        class="score">
                        {{ e.examDataStatus =='YJJDPG' ? '批阅中' : `${e.score ? e.score : 0 }分` }}
                        
                    </div>
                </div>
            </div>
        </div>
        <!-- <el-pagination @current-change="handleCurrentChange" background :current-page.sync="query.current"
            :page-size="10" layout="prev, pager, next, jumper" :total="tableData.total">
        </el-pagination> -->
    </div>
</template>

<script>
import Navigation from "@/components/Navigation.vue";
import { myPapers, start } from "@/api/myTest.js";
import { mapState, mapMutations } from "vuex";
export default {
    name: "",
    components: {
        Navigation
    },
    data() {
        return {
            navigationRoute: [
                { name: '我的测试' },
                { name: '我的考试' },
            ],
            query: {
                current: 1,
                size: 10
            },
            tableData: { //表格数据
                total: 0,
                records: []
            },
            list:[]
        };
    },
    created() {
        this.getList()
    },
    computed: {

    },
    methods: {
        handleCurrentChange(val) {
            this.query.current = val
            this.getList()
        },
        getList(pageNumber, pageSize) {
            this.query.current = pageNumber || this.query.current
            this.query.size = pageSize || this.query.size
            myPapers(this.query).then(res => {
                this.list = res
            })
        },
        start(e) {
           const now=new Date().getTime(),
            sTime=new Date(e.startTime).getTime(),  
            eTime=new Date(e.endTime).getTime();
            
            if(now>eTime||sTime>now){
                this.$message({
                  message: '不在考试时间范围内',
                  type: 'error'
                })
                return 
            }
            this.$router.push({
                path: '/myTest/myPaperList/myPaper',
                query: {
                    paperId: e.id
                }
            })
        },
        view(e) {
            this.$router.push({
                path: '/myTest/myPaperList/myPaperView',
                query: {
                    paperId: e.id,
                    dataId: e.examDataId,
                }
            })
        }
    },
};
</script>
<style lang="scss" scoped>
.paper-item {
    margin-top: 20px;
    background: #FDF2F1;
    border-radius: 5px 5px 5px 5px;
    padding: 10px 20px;
    font-weight: 400;
    font-size: 14px;
    color: #767676;
    display: flex;
    align-items: center;

    .paper-item-title {
        font-weight: 500;
        font-size: 16px;
        color: #1A1A1A;
    }

    .paper-item-left {
        flex: 1;

        &>div {
            margin: 10px 0;
        }

        .paper-item-left-b {
            display: flex;

            &>div {
                margin-right: 10px;
            }
        }
    }

    .paper-item-right {
        width: 100px;
    }

    .score {
        color: #E1311A;
        font-weight: 400;
        font-size: 24px;
        line-height: 24px;
        text-align: right;
        cursor: pointer;
    }
}

.paper-item-df {
    background: #FFF9F2;
}
.overS{
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 840px;
}
</style>